import { Badge } from '@mui/material';
import { twMerge } from 'tailwind-merge';

import { useValidationByRules } from 'hooks';

import { Icon } from '../icons';

import { FieldValidationRulesProps } from './types';

export const FieldValidationRules = ({
  name,
  rules,
}: FieldValidationRulesProps) => {
  const validationResult = useValidationByRules({ rules, fieldName: name });

  return (
    <div className="flex flex-col gap-1">
      {Object.keys(rules).map((ruleName) => {
        const isValidRule = validationResult[ruleName];
        const iconClass = twMerge(
          '[&_path]:fill-graydark-primary',
          isValidRule && '[&_path]:fill-green-600'
        );

        const textClass = twMerge(
          'text-graydark-primary text-xs',
          isValidRule && 'text-green-600'
        );

        return (
          <Badge key={ruleName}>
            <div className="flex items-center gap-1">
              <Icon.CheckCircle className={iconClass} />
              <p className={textClass}>{ruleName}</p>
            </div>
          </Badge>
        );
      })}
    </div>
  );
};
